export default __webpack_public_path__ + "static/media/7.5f420c37.svg";